// <product-quiz> (§7.2): una pregunta por pantalla con «Atrás», progreso en texto, foco en el <legend>
// de cada paso y la URL con ?paso= (el botón atrás del navegador funciona).
// Las respuestas no salen del navegador: a la analítica solo va el código del resultado.
const QUIZ_GRAPH = {
  P1: { a: 'P2', b: 'P5', c: 'V' },
  P2: { si: 'P3', no: 'V2' },
  P3: { si: 'V3', no: 'P4' },
  P4: 'weight',
  P5: { no: 'B1', si: 'P6' },
  P6: { si: 'V4', no: 'B2' },
};

class ProductQuiz extends HTMLElement {
  connectedCallback() {
    this.hidden = false;
    this.form = this.querySelector('form');
    this.s = JSON.parse(this.dataset.strings);
    this.range = JSON.parse(this.dataset.range || 'null');
    this.history = [];
    this.started = false;
    this.back = this.querySelector('[data-back]');
    this.next = this.querySelector('[data-next]');
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.answer();
    });
    this.back.addEventListener('click', () => history.back());
    this.addEventListener('click', (event) => {
      const cta = event.target.closest('[data-quiz-cta]');
      if (cta) window.Shopify?.analytics?.publish?.('pawly:quiz_cta_click', { result_code: this.result, cta: cta.dataset.quizCta });
      if (event.target.closest('[data-restart]')) this.go('P1', [], true);
      const follow = event.target.closest('[data-follow-up]');
      if (follow) this.go(follow.dataset.followUp, [...this.history, this.current], true);
    });
    window.addEventListener('popstate', (event) => {
      const state = event.state?.quiz;
      if (state) this.show(state.node, state.history, false);
      else this.show('P1', [], false);
    });
    this.show('P1', [], false, false);
  }

  go(node, historyStack, push) {
    if (push) {
      // Conserva los demás parámetros de la URL (en Shopify, p. ej. preview_theme_id al previsualizar el tema).
      const url = new URL(location.href);
      url.searchParams.set('paso', historyStack.length + 1);
      history.pushState({ quiz: { node, history: historyStack } }, '', url);
    }
    this.show(node, historyStack, true);
  }

  show(node, historyStack, focus = true) {
    this.current = node;
    this.history = historyStack;
    const isResult = !QUIZ_GRAPH[node];
    this.querySelectorAll('[data-question]').forEach((fs) => { fs.hidden = fs.dataset.question !== node; });
    this.querySelectorAll('[data-result]').forEach((r) => { r.hidden = r.dataset.result !== node; });
    this.form.hidden = isResult;
    this.back.hidden = historyStack.length === 0;
    this.querySelector('.quiz__progress').textContent = isResult ? '' : this.s.progress.replace('{{ n }}', historyStack.length + 1);
    if (isResult) {
      this.result = node;
      window.Shopify?.analytics?.publish?.('pawly:quiz_complete', { result_code: node });
      if (focus) this.querySelector(`[data-result="${node}"] h2`)?.focus();
    } else if (focus) {
      this.querySelector(`[data-question="${node}"] legend`)?.focus();
    }
  }

  answer() {
    const node = this.current;
    const rule = QUIZ_GRAPH[node];
    const fs = this.querySelector(`[data-question="${node}"]`);
    let target;
    if (rule === 'weight') {
      const input = fs.querySelector('input');
      const error = fs.querySelector('.field__error');
      const value = Number(String(input.value).replace(',', '.'));
      if (!input.value.trim() || !Number.isFinite(value) || value <= 0 || value > 90) {
        error.querySelector('span').textContent = this.s.weight;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      error.hidden = true;
      input.removeAttribute('aria-invalid');
      // Sin rango de peso en la tabla (la del proveedor solo trae el pecho), el peso no descarta a nadie: la talla se elige
      // midiendo el pecho, así que se va a A (que lo explica) y no a FUERA («no tenemos su talla»).
      target = !this.range || (value >= this.range.min && value <= this.range.max) ? 'A' : 'FUERA';
    } else {
      const chosen = fs.querySelector('input:checked');
      const error = fs.querySelector('.quiz__error');
      if (!chosen) {
        error.querySelector('span').textContent = this.s.choose;
        error.hidden = false;
        fs.querySelector('input')?.focus();
        return;
      }
      error.hidden = true;
      target = rule[chosen.value];
    }
    if (!this.started) {
      this.started = true;
      window.Shopify?.analytics?.publish?.('pawly:quiz_start', {});
    }
    this.go(target, [...this.history, node], true);
  }
}

customElements.define('product-quiz', ProductQuiz);
